
import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MarkdownPipe } from 'ngx-markdown';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { InlineSVGDirective } from 'src/app/core/inline-svg/inline-svg.directive';
import { MetaPage } from 'src/app/models';
import * as PropertyActions from '../../core/store/properties.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/core.state';
import { TPipe } from '../../core/i18n/t.pipe';

@Component({
  selector: 'facebookpage-selector',
  templateUrl: './facebookpage-selector.component.html',
  styleUrls: ['./facebookpage-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TPipe, InlineSVGDirective, ReactiveFormsModule]
})
export class FacebookPageSelectorComponent implements OnInit {

  @Input() pages: MetaPage[];
  @Input() property_id: number;
  facebookPagesList: FormGroup;


  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private store: Store<AppState>) {

        this.facebookPagesList = this.fb.group({
            pageslist: new FormArray([]),
          });

  }

  ngOnInit() {
    this.initPagesFormArray();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pages']) {
      this.initPagesFormArray();
    }
  }

  private initPagesFormArray() {
    const pagesArray = this.facebookPagesList.get('pageslist') as FormArray;
    pagesArray.clear();
    if (this.pages && this.pages.length) {
      this.pages.forEach(() => {
        pagesArray.push(this.fb.control(false));
      });
    }
  }

  linkPages(){
    const selectedBools = this.facebookPagesList.value.pageslist;
    const selectedPages = this.pages
      .map((page, i) => selectedBools[i] ? page : null)
      .filter(page => page !== null);

    this.store.dispatch(PropertyActions.FacebookSubscribeRequest({pages: selectedPages, property_id: this.property_id}));
    this.activeModal.close();
  }

  close() {
    this.activeModal.close();
  }
}
